import { render, staticRenderFns } from "./datas.vue?vue&type=template&id=3e6b0a24&scoped=true"
import script from "./datas.vue?vue&type=script&lang=ts"
export * from "./datas.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e6b0a24",
  null
  
)

export default component.exports